import type { MessageTemplateContextShape } from '@post-office/shared-contracts/types';

export const SPOTLIGHT_DISMISS_EVENT = 'dismissSpotlightTour';

/**
 * The MessageTemplateContext defines the shape of the data you want users to include
 * when they send this message. If you update this run yarn generate:all to update the system
 * with your new MessageTemplateContext
 */
export type MessageTemplateContext = MessageTemplateContextShape<{
	testProp: string;
}>;
